// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__ZDErs","row":"ProcedureTreatmentSummary_row__1SRuD"};